/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages,
    GetPressReleaseHistorySuccessResponsePressReleaseHistoryImagesFromJSON,
    GetPressReleaseHistorySuccessResponsePressReleaseHistoryImagesFromJSONTyped,
    GetPressReleaseHistorySuccessResponsePressReleaseHistoryImagesToJSON,
} from './GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages';

/**
 * 
 * @export
 * @interface GetPressReleaseHistorySuccessResponsePressReleaseHistory
 */
export interface GetPressReleaseHistorySuccessResponsePressReleaseHistory {
    /**
     * リリース履歴の一意の識別子
     * @type {number}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    releaseHistoryId: number;
    /**
     * プレスリリースのタイトル
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    title: string;
    /**
     * プレスリリースのサブタイトル
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    subtitle: string;
    /**
     * プレスリリースの本文
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    text: string;
    /**
     * メイン画像のファイル名
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    imageFileNameMain: string;
    /**
     * メイン画像のS3に保存されたファイル名
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    imageFileNameMainS3: string;
    /**
     * プレスリリースに関連する画像のリスト
     * @type {Array<GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages>}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    images: Array<GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages>;
    /**
     * ドキュメントファイル1のファイル名
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    referenceFileName: string;
    /**
     * ドキュメントファイル2のファイル名
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    releaseFileName: string;
    /**
     * メディア限定ドキュメントファイル1のファイル名
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    mediaReleaseFileName: string;
    /**
     * メディア限定ドキュメントファイル2のファイル名
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    mediaReferenceData: string;
    /**
     * プレスリリースを変更した企業ユーザーの名前
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    changedByCompanyUserName: string;
    /**
     * プレスリリースが変更された日時（ISO 8601形式）
     * @type {Date}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistory
     */
    changedAt: Date;
}

export function GetPressReleaseHistorySuccessResponsePressReleaseHistoryFromJSON(json: any): GetPressReleaseHistorySuccessResponsePressReleaseHistory {
    return GetPressReleaseHistorySuccessResponsePressReleaseHistoryFromJSONTyped(json, false);
}

export function GetPressReleaseHistorySuccessResponsePressReleaseHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseHistorySuccessResponsePressReleaseHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseHistoryId': json['release_history_id'],
        'title': json['title'],
        'subtitle': json['subtitle'],
        'text': json['text'],
        'imageFileNameMain': json['image_file_name_main'],
        'imageFileNameMainS3': json['image_file_name_main_s3'],
        'images': ((json['images'] as Array<any>).map(GetPressReleaseHistorySuccessResponsePressReleaseHistoryImagesFromJSON)),
        'referenceFileName': json['reference_file_name'],
        'releaseFileName': json['release_file_name'],
        'mediaReleaseFileName': json['media_release_file_name'],
        'mediaReferenceData': json['media_reference_data'],
        'changedByCompanyUserName': json['changed_by_company_user_name'],
        'changedAt': (new Date(json['changed_at'])),
    };
}

export function GetPressReleaseHistorySuccessResponsePressReleaseHistoryToJSON(value?: GetPressReleaseHistorySuccessResponsePressReleaseHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_history_id': value.releaseHistoryId,
        'title': value.title,
        'subtitle': value.subtitle,
        'text': value.text,
        'image_file_name_main': value.imageFileNameMain,
        'image_file_name_main_s3': value.imageFileNameMainS3,
        'images': ((value.images as Array<any>).map(GetPressReleaseHistorySuccessResponsePressReleaseHistoryImagesToJSON)),
        'reference_file_name': value.referenceFileName,
        'release_file_name': value.releaseFileName,
        'media_release_file_name': value.mediaReleaseFileName,
        'media_reference_data': value.mediaReferenceData,
        'changed_by_company_user_name': value.changedByCompanyUserName,
        'changed_at': (value.changedAt.toISOString()),
    };
}

